// Vendor libraries
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { FundamentalChartModule } from '../fundamental-chart/fundamental-chart.module';
// Module imports
import { ConfigModule } from 'NewAngular/config/config.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class SingleSeriesFundChartModule {
}
SingleSeriesFundChartModule.ɵfac = function SingleSeriesFundChartModule_Factory(t) { return new (t || SingleSeriesFundChartModule)(); };
SingleSeriesFundChartModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SingleSeriesFundChartModule });
SingleSeriesFundChartModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        BrowserModule,
        FormsModule,
        IconModule,
        ConfigModule,
        TooltipModule,
        FeatureNeededModule,
        FundamentalChartModule] });
